import React, { useEffect, useState } from "react";
import { AlertTriangle, Plus } from "lucide-react";
import { api } from "../../lib/api";

// Step 5 feed: Rate-Limiter skills that current coach entries need, ordered by how many teams list them.
export function FixNowStrip({ playerId, admin, existing = [], onAdd, refreshKey }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.coachFixNow(playerId).then(setD).catch(() => setD(null)); }, [playerId, refreshKey]);
  if (!d || !d.currentEntries) return null;
  const has = (name) => existing.some(x => (x || "").toLowerCase().includes(name.toLowerCase()));
  return (
    <div className="border border-[#f87171]/30 bg-[#141010] p-4" data-testid="fix-now-strip">
      <div className="text-[10px] uppercase tracking-[0.35em] font-bold text-[#f87171] flex items-center gap-2"><AlertTriangle className="w-3.5 h-3.5" /> Fix Now candidates from coaches</div>
      <div className="text-[10px] text-[#757575] mt-0.5 mb-3">Skills your current coaches need that are rated Rate Limiter · from {d.currentEntries} current team{d.currentEntries > 1 ? "s" : ""}</div>
      {!d.hasAssessment && <div className="text-xs text-[#a0a0a0]">Complete an assessment to compare.</div>}
      {d.hasAssessment && d.candidates.length === 0 && <div className="text-xs text-[#a0a0a0]" data-testid="fix-now-empty">No Rate Limiters among the skills coaches asked for.</div>}
      <div className="flex flex-wrap gap-2">
        {d.candidates.map(c => (
          <div key={c.skillId} className="flex items-center gap-2 border border-[#f87171]/40 bg-[#1a1212] pl-3 pr-1.5 py-1.5" data-testid={`fix-now-${c.skillId}`}>
            <span className="text-sm text-white">{c.name}</span>
            <span className="text-[10px] text-[#f87171] tabular-nums" title={c.teams.join(", ")}>{c.count} team{c.count > 1 ? "s" : ""}</span>
            {c.sources?.includes("Team system") && <span className="text-[8px] uppercase tracking-[0.25em] px-1.5 py-0.5 border border-[#60a5fa]/40 text-[#60a5fa]" data-testid={`fix-now-source-${c.skillId}`}>Team system</span>}
            {admin && (has(c.name)
              ? <span className="text-[9px] uppercase tracking-widest text-[#4ade80] px-1.5">Added</span>
              : <button onClick={() => onAdd(c)} className="text-[9px] uppercase tracking-widest px-2 py-1 border border-white/15 text-[#c0c0c0] hover:text-white hover:border-white/30 flex items-center gap-1" data-testid={`fix-now-add-${c.skillId}`}><Plus className="w-3 h-3" /> Add to priorities</button>)}
          </div>
        ))}
      </div>
    </div>
  );
}
